module.exports = __webpack_public_path__ + "img/itx-text-subscript.20ef7d78.svg";